export default __webpack_public_path__ + "static/media/2018.ebf658f0.png";